export function translatePlanningNotificationStatus(t, statusRaw) {
  const norm = String(statusRaw || '')
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_')
  const codeKeys = {
    draft: 'planning.status_draft',
    review: 'planning.status_review',
    in_review: 'planning.status_review',
    additional: 'planning.status_additional',
    approved: 'planning.status_approved',
    rejected: 'planning.status_rejected',
    released: 'planning.status_released',
  }
  const key = codeKeys[norm]
  if (key) return t(key)
  if (norm.includes('review')) return t('planning.status_review')
  return String(statusRaw || '').trim()
}
